export function generateDeviceFingerprint(): string {
  const components = [
    navigator.userAgent,
    navigator.language,
    new Date().getTimezoneOffset().toString(),
    screen.width.toString(),
    screen.height.toString(),
    screen.colorDepth.toString(),
    navigator.hardwareConcurrency?.toString() || '',
    navigator.deviceMemory?.toString() || '',
    navigator.platform,
  ];

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (ctx) {
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('TrezoOne', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('TrezoOne', 4, 17);
    components.push(canvas.toDataURL());
  }

  const fingerprint = components.join('|||');

  return hashString(fingerprint);
}

function hashString(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }

  return Math.abs(hash).toString(36);
}

export function getDeviceName(): string {
  const ua = navigator.userAgent;
  let deviceName = 'Appareil inconnu';

  if (/Mobile|Android|iPhone|iPad|iPod/i.test(ua)) {
    if (/iPhone/i.test(ua)) deviceName = 'iPhone';
    else if (/iPad/i.test(ua)) deviceName = 'iPad';
    else if (/Android/i.test(ua)) deviceName = 'Android';
    else deviceName = 'Mobile';
  } else {
    if (/Windows/i.test(ua)) deviceName = 'Windows PC';
    else if (/Mac/i.test(ua)) deviceName = 'Mac';
    else if (/Linux/i.test(ua)) deviceName = 'Linux';
    else deviceName = 'Ordinateur';
  }

  let browser = '';
  if (/Chrome/i.test(ua) && !/Edg/i.test(ua)) browser = ' (Chrome)';
  else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = ' (Safari)';
  else if (/Firefox/i.test(ua)) browser = ' (Firefox)';
  else if (/Edg/i.test(ua)) browser = ' (Edge)';

  return deviceName + browser;
}
